import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HisHtmlUtils } from '../utils';

@Pipe( {
    name: 'hisHtmlSafe',
    standalone: false
} )
/**
 * Pipe to sanitize HTML content by filtering unsafe tags and attributes.
 * This pipe uses utility class `HisHtmlUtils` to filter and sanitizing the HTML before bypassing Angular DOMSanitizer.
 */
export class HisHtmlSafePipe implements PipeTransform {
    private sanitizer = inject( DomSanitizer );


    transform( html: string ): SafeHtml {
        if ( html ) {
            return this.sanitizer.bypassSecurityTrustHtml( HisHtmlUtils.filterHtml( html ) );
        } else {
            return '';
        }
    }
}
